import { createSlice } from '@reduxjs/toolkit';
import { fetchCodeOTP } from './otpUtils';

const CodeOTPSlice = createSlice({
  name: 'CodeOTP',
  initialState: {
    data: {},
    isLoading: false,
  },
  reducers: {
    resetCodeOTP: (state) => {
      state.data = {};
    }
  },
  extraReducers: {
    [fetchCodeOTP.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchCodeOTP.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    [fetchCodeOTP.rejected]: (state) => {
      state.isLoading = false;
    },
  }
});

export const { resetCodeOTP } = CodeOTPSlice.actions;

export default CodeOTPSlice.reducer;